import { Typography } from '@genial/design-tokens';
import { Text } from 'native-base';
import React from 'react';

interface TableContentItemLabelProps {
  children: React.ReactNode;
}

export const TableContentItemLabel: React.FC<TableContentItemLabelProps> = ({ children }) => (
  <Text color="neutral.medium" fontSize={Typography['fontsize.xs']}>
    {children}
  </Text>
);
